import * as weatherApi from '@/api/weather/index';
import { WeatherData } from '@/api/weather/types';
import store from '@/store';
import * as mt from '@/store/weather/mutation-types';
import { WeatherState } from '@/store/weather/types';


export function getCurrentKey(farmUuid: string) {
  return farmUuid;
}

export function getHistoricalKey(farmUuid: string, untilYear: number) {
  return `${farmUuid}_${untilYear}`;
}

export function getPeriodKey(farmUuid: string, fromYear: number, untilYear: number) {
  return `${farmUuid}_${fromYear}_${untilYear}`;
}

export async function cleanupTemperature() {
  await store.dispatch(`weather/${mt.CLEANUP_TEMPERATURE}`);
}

export async function fetchCurrentTemperatureAverage(farmUuid: string) {
  const key = getCurrentKey(farmUuid);
  // @ts-ignore
  const status = (store.state.weather as WeatherState).currentTemperatureAverageStatus.get(key);

  if (!status?.startsWith('fetching')) {
    await store.dispatch(`weather/${mt.FETCHING_CURRENT_TEMPERATURE_AVERAGE}`, key);
    try {
      const averages = (await weatherApi.getLastTwelveMonthsAverage(farmUuid, 'TEMPERATURE')).data;
      await store.dispatch(`weather/${mt.FETCH_CURRENT_TEMPERATURE_AVERAGE}`,
        { 
          cacheKey: key,
          weatherDataList: averages
        }
      );
    } catch (error) {
      await store.dispatch(`weather/${mt.FETCH_CURRENT_TEMPERATURE_FAILURE}`, key);
    }
  }
}

export async function fetchHistoricalTemperatureAverage(farmUuid :string, untilDate: Date) {
  const key = getHistoricalKey(farmUuid, untilDate.getFullYear());
  // @ts-ignore
  const status = (store.state.weather as WeatherState).historicalTemperatureAverageStatus.get(key);

  if (!status?.startsWith('fetching')) {
    await store.dispatch(`weather/${mt.FETCHING_HISTORICAL_TEMPERATURE_AVERAGE}`, key);
    try {
      const averages = (await weatherApi.getHistoricalAverage(farmUuid, 'TEMPERATURE', untilDate ? untilDate : new Date)).data;
      await store.dispatch(`weather/${mt.FETCH_HISTORICAL_TEMPERATURE_AVERAGE}`,
        { 
          cacheKey: key,
          weatherDataList: averages
        }
      );
    } catch (error) {
      await store.dispatch(`weather/${mt.FETCH_HISTORICAL_TEMPERATURE_FAILURE}`, key);
    }
  }
}

export async function fetchPeriodTemperatureAverage(farmUuid :string, fromDate: Date, untilDate: Date) {
  const key = getPeriodKey(farmUuid, fromDate.getFullYear(), untilDate.getFullYear());
  // @ts-ignore
  const status = (store.state.weather as WeatherState).periodTemperatureAverageStatus.get(key);

  if (!status?.startsWith('fetching')) {
    await store.dispatch(`weather/${mt.FETCHING_PERIOD_TEMPERATURE_AVERAGE}`, key);
    try {
      const averages = (await weatherApi.getPeriodAverage(farmUuid, 'TEMPERATURE', fromDate, untilDate)).data;
      await store.dispatch(`weather/${mt.FETCH_PERIOD_TEMPERATURE_AVERAGE}`,
        { 
          cacheKey: key,
          weatherDataList: averages
        }
      );
    } catch (error) {
      await store.dispatch(`weather/${mt.FETCH_PERIOD_TEMPERATURE_FAILURE}`, key);
    }
  }
}


export async function cleanupSPI4() {
  await store.dispatch(`weather/${mt.CLEANUP_SPI4}`);
}

export async function fetchCurrentSPI4Average(farmUuid :string) {
  const key = getCurrentKey(farmUuid);
  // @ts-ignore
  const status = (store.state.weather as WeatherState).currentSPI4AverageStatus.get(key);

  if (!status?.startsWith('fetching')) {
    await store.dispatch(`weather/${mt.FETCHING_CURRENT_SPI4_AVERAGE}`, key);
    try {
      const averages = (await weatherApi.getLastTwelveMonthsAverage(farmUuid, 'SPI')).data;
      await store.dispatch(`weather/${mt.FETCH_CURRENT_SPI4_AVERAGE}`,
        { 
          cacheKey: key,
          weatherDataList: averages
        }
      );
    } catch (error) {
      await store.dispatch(`weather/${mt.FETCH_CURRENT_SPI4_FAILURE}`, key);
    }
  }
}

export async function fetchHistoricalSPI4Average(farmUuid :string, untilDate: Date) {
  const key = getHistoricalKey(farmUuid, untilDate.getFullYear());
  // @ts-ignore
  const status = (store.state.weather as WeatherState).historicalSPI4AverageStatus.get(key);

  if (!status?.startsWith('fetching')) {
    await store.dispatch(`weather/${mt.FETCHING_HISTORICAL_SPI4_AVERAGE}`, key);
    try {
      const averages = (await weatherApi.getHistoricalAverage(farmUuid, 'SPI', untilDate ? untilDate : new Date)).data;
      await store.dispatch(`weather/${mt.FETCH_HISTORICAL_SPI4_AVERAGE}`,
        { 
          cacheKey: key,
          weatherDataList: averages
        }
      );
    } catch (error) {
      await store.dispatch(`weather/${mt.FETCH_HISTORICAL_SPI4_FAILURE}`, key);
    }
  }
}

export async function fetchPeriodSPI4Average(farmUuid :string, fromDate: Date, untilDate: Date) {
  const key = getPeriodKey(farmUuid, fromDate.getFullYear(), untilDate.getFullYear());
  // @ts-ignore
  const status = (store.state.weather as WeatherState).periodSPI4AverageStatus.get(key);

  if (!status?.startsWith('fetching')) {
    await store.dispatch(`weather/${mt.FETCHING_PERIOD_SPI4_AVERAGE}`, key);
    try {
      const averages = (await weatherApi.getPeriodAverage(farmUuid, 'SPI', fromDate, untilDate)).data;
      await store.dispatch(`weather/${mt.FETCH_PERIOD_SPI4_AVERAGE}`,
        { 
          cacheKey: key,
          weatherDataList: averages
        }
      );
    } catch (error) {
      await store.dispatch(`weather/${mt.FETCH_PERIOD_SPI4_FAILURE}`, key);
    }
  }
}



export async function cleanup() {
  await Promise.all([cleanupSPI4(), cleanupTemperature()])
}
